import React from 'react';

import { StoreSwitcherModal } from '../../components/StoreSwitcherModal/StoreSwitcherModal';
import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { modalHooks } from '../../hooks/modalHooks/modalHooks';
import { StoreSwitcherMessages } from '../../types/Messages';
import { ModalTypes } from '../../types/Modals';

export const hooks = {
  useGetStates() {
    const setIsFooterPart = messageHooks.useNextWithValue(
      StoreSwitcherMessages.isNonBlockPart, false,
    );
    return {
      setIsFooterPart,
    };
  },
  useGetOnCloseModal(
    setIsFooterPart: () => void,
    handleCloseParticularModal: () => void,
  ) {
    const handleCloseModal = React.useCallback(() => {
      setIsFooterPart();
      handleCloseParticularModal();
    }, [handleCloseParticularModal, setIsFooterPart]);
    return { handleCloseModal };
  },
};

export const StoreSwitcherModalContainer = () => {
  const {
    isOpenModal,
    onModalClose,
  } = modalHooks.useModal(ModalTypes.StoreSwitcherModal);

  const {
    setIsFooterPart,
  } = hooks.useGetStates();

  const { handleCloseModal } = hooks.useGetOnCloseModal(
    setIsFooterPart, onModalClose,
  );

  return (
    <StoreSwitcherModal
      isOpen={isOpenModal()}
      onModalClose={handleCloseModal}
    />
  );
};

StoreSwitcherModalContainer.displayName = 'StoreSwitcherModalContainer';
